import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";



function Rp1(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
 

    const [filterParam, setFilterParam] = useState({   

 
       
        nazwa:  props.mainView.readFilter('nazwa',''),    
        nip:  props.mainView.readFilter('nip',''),   
        rok:  props.mainView.readFilter('rok', (new Date()).getFullYear() ),   
        miesiac:  props.mainView.readFilter('miesiac',  (new Date()).getMonth()+1 ),   
 
 
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);


    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);


    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'obciążenie',
             filter: {  filed: "strona", set: "wn", typ: "combo"  },
        }, {
            cls:'color_show2',
            title: 'uznanie',
             filter: {  filed: "strona", set: "ma", typ: "combo"  },
        },
    ]);





        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

           
            props.mainView.writeFilter('nazwa', ''); 
            props.mainView.writeFilter('nip', '');
            props.mainView.writeFilter('rok',   (new Date()).getFullYear()  );
            props.mainView.writeFilter('miesiac',  (new Date()).getMonth()+1);
 
          
           
            setFilterParam({
 
                nazwa: '',                                        
                nip: '',                                        
                rok: (new Date()).getFullYear()  ,                                        
                miesiac:  (new Date()).getMonth()+1 ,                                        
                            
              
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_rap,rp1', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }




    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }


  

    const keyListener = (e) => {


                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27  )  
                        {
                                setView({v:'list',id:-1});
                                filterClear();
                        }else                                                     
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }else    
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Rp1.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Rp1.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();         
        return <div>
            ...
        </div>
    }

 

    
    
    
    var dialogBox = null;

   
 


    
    if(view.v == 'client')
    {
     //  return <ClientReview userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id}   />
    }
 
  
        var sortList = [                                        
        {column: "firma_nazwa", name: "Nazwa firmy"  },
        {column: "numer_faktury", name: "Numer faktury"  },
    ]


        document.title = "Raport okresowy 1" ;

      
    var titleRaport = "Raport V1 " + filterParam.rok + '-' + filterParam.miesiac;    
    

    var razemNetto = 0.0;
    var razemVat = 0.0;
    var razemBrutto = 0.0;


    for(var k=0; k < tab.length; k++)
    {
        razemNetto = parseFloat(razemNetto) + parseFloat( tab[k].razem_netto );
        razemVat = parseFloat(razemVat) + parseFloat( tab[k].razem_vat );
        razemBrutto = parseFloat(razemBrutto) + parseFloat( tab[k].razem_brutto );
    }


    return  <div className="view_content">


                 
               <h3 className="dash_header">Raport okresowy (v1)</h3>

               <div className="tip">Raport przedstawia listę faktur, które w swoich pozycjach zawierają informacje o okresie, np. Abonament 2025-09</div>
                              

    
               <div className="table_filter">

                      
                        <div className="filter_controll">   
                                                <label>Klient: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                        </div> 
                                     

                         <div className="filter_controll">   
                                            <label>NIP: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"Nip: "}   />
                        </div>  
 
                        <div className="filter_controll">   
                                            <label>Rok: </label>                             
                                            <InputComboRok noempty='1'  userData={props.userData} value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}   />
                        </div>  

                        <div className="filter_controll">   
                                            <label>Miesiąc: </label>                             
                                            <InputComboMiesiac  noempty='1'  userData={props.userData} value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}   />
                        </div>  
                        

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                                                    

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                                    &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />


                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">



                
                            <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>  

                                <table className="table" ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Numer</td>                                                                                                                                                                                              
                                                <td>Data wystawienia</td>                                                                                                                                                                                              
                                                <td>Klient</td>                                                                                                                                                                                                                                                                                   
                                                <td>Wartość Netto</td>                                                                                                                                                                                                                                                                                   
                                                <td>Wartość Vat</td>                                                                                                                                                                                                                                                                                   
                                                <td className="td_right">Wartość Brutto</td>                                                                                                
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
  
                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter" >{row.numer_dokumentu}</td>                                                                                                       
                                                                <td className="gocenter"  >{row.data_wystawienia}</td>                                                                                                       
                                                                <td className="goleft" >{row.klient.nazwa}</td>                                                                                                                                                                                                                                             
                                                                <td className="goright" ><FormatDecimal value={row.razem_netto} /> </td>                                                                                                                                                                                                                                                                                                                                                
                                                                <td className="goright" ><FormatDecimal value={row.razem_vat} /> </td>                                                                                                                                                                                                                                                                                                                                                
                                                                <td className="goright" ><FormatDecimal value={row.razem_brutto} /> </td>                                                                                                                                                                                                                                                                                                                                                
                                                            </tr>

                                                    } )
                                                }
 
                                             <tr className="">                                                                                               
                                                <td className="td_left"> </td>                                                                                                                                                                                 
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={razemNetto} /></td>                                                                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={razemVat} /></td>                                                                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={razemBrutto} /></td>                                                                                                                                                                                                        
                                            </tr>

                                        </tbody>

                                </table>
                            </div>

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Numer</td>                                                                                                                                                                                              
                                                <td>Data wystawienia</td>                                                                                                                                                                                              
                                                <td>Klient</td>                                                                                                                                                                                                                                                                                   
                                                <td>Wartość Netto</td>                                                                                                                                                                                                                                                                                   
                                                <td>Wartość Vat</td>                                                                                                                                                                                                                                                                                   
                                                <td className="td_right">Wartość Brutto</td>                                                                                                
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
  
                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter" >{row.numer_dokumentu}</td>                                                                                                       
                                                                <td className="gocenter"  >{row.data_wystawienia}</td>                                                                                                       
                                                                <td className="goleft" >{row.klient.nazwa}</td>                                                                                                                                                                                                                                             
                                                                <td className="goright" ><FormatDecimal value={row.razem_netto} /> </td>                                                                                                                                                                                                                                                                                                                                                
                                                                <td className="goright" ><FormatDecimal value={row.razem_vat} /> </td>                                                                                                                                                                                                                                                                                                                                                
                                                                <td className="goright" ><FormatDecimal value={row.razem_brutto} /> </td>                                                                                                                                                                                                                                                                                                                                                
                                                            </tr>

                                                    } )
                                                }
 
                                            <tr className="">                                                                                               
                                                <td className="td_left"> </td>                                                                                                                                                                                 
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={razemNetto} /></td>                                                                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={razemVat} /></td>                                                                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={razemBrutto} /></td>                                                                                                                                                                                                        
                                            </tr>

                                        </tbody>

                                </table>

               </div>
 
              

                              
           {dialogBox}

    </div>
}


export default Rp1;